import { useId } from 'react';

export function useChartGradientId(name: string): string {
  const id = useId().replace(/:/g, '');
  return `${name}-${id}`;
}

export function chartGradientFill(id: string): string {
  return `url(#${id})`;
}
